import { render, staticRenderFns } from "./ShareButtonsFeature.vue?vue&type=template&id=52e4d6f0&scoped=true&"
import script from "./ShareButtonsFeature.vue?vue&type=script&lang=ts&"
export * from "./ShareButtonsFeature.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButtonsFeature.vue?vue&type=style&index=0&id=52e4d6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4d6f0",
  null
  
)

component.options.__file = "ShareButtonsFeature.vue"
export default component.exports